import { CatmullRomLine } from '@react-three/drei'

export default function Floor(props) {

    const colors = props.colors
    const deg= Math.PI*2/360
    const lineWidth = 1.2
    const linesDist = 0.12
    const lineLength = 0.5
    const linePpoints= [[lineLength*-1,0,0],[lineLength,0,0]]

  return (
    <>  
         <group>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*-3)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*-1)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*-2)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*0)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*1)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*2)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*3)]}/>
   
        </group>

        <group rotation={[0,90*deg,0]}>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*-3)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*-2)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*-1)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*0)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*1)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*2)]}/>
         <CatmullRomLine points={linePpoints} color={props.isDark?colors.night:colors.day} linewidth={lineWidth} position={[0,0,(linesDist*3)]}/>
        </group>
    </>
   
  )
}
